import { render, staticRenderFns } from "./addListWindow.vue?vue&type=template&id=08a38b72&"
import script from "./addListWindow.vue?vue&type=script&lang=js&"
export * from "./addListWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports